import { useEffect } from "react";
import { LoadingOverlay } from "@/apps/@components";
import { LiffModule } from "@/apps/modules";
import { api } from "@/apps/@utils";

export default function ShareModulePage() {

    useEffect(() => {
        (async () => {
            const flexMessage = (await api.get("/share-module/flex-message")).data;
            LiffModule.sendFlexMessages(flexMessage, true);
        })();

    }, []);

    return (
        <LoadingOverlay visible={true} />
    )
}
